
















import { Component, Prop, Vue } from "vue-property-decorator";

import GroupNode0 from "./groupNode0/groupNode0.vue"
import Node from "./node/node.vue"

import * as def from "@/definitions";
@Component({
  components: {
      GroupNode0,
      Node
    }
})
export default class UnDraggableTree extends Vue
{
    @Prop() nodes! : any[];
    @Prop() selectedNode! : any;

    get rootData():def.Data{
        return this.$store.getters.data
    }

    get hierarchy(){
        return 0;
    }

    select(id : number){
        this.rootData.selectImageCategory(id);
        // イベントを飛ばす
        this.$emit("selectImageCategory");
    }

    open(id : number){
        this.rootData.openImageCategory(id)
    }

}
